// extracted by mini-css-extract-plugin
export default {"videoContainer":"youtube-link_videoContainer__n1GcG"};